import { Paper, Stack, Typography } from '@mui/material';
import { formatCompact } from '../viz/tokens';

interface StatTileProps {
  label: string;
  value: number;
  caption?: string;
}

/**
 * Glass stat tile — headline number on a translucent card with a light lift
 * on hover (handled by the global MuiPaper / card motion language).
 */
export default function StatTile({ label, value, caption }: StatTileProps) {
  return (
    <Paper
      sx={{
        p: 2.75,
        flex: '1 1 180px',
        minWidth: 160,
        position: 'relative',
        overflow: 'hidden',
        '&:hover': {
          transform: 'translateY(-3px)',
        },
        '&::after': {
          content: '""',
          position: 'absolute',
          inset: 0,
          background:
            'linear-gradient(135deg, rgba(255,255,255,0.12) 0%, transparent 42%)',
          pointerEvents: 'none',
        },
      }}
    >
      <Stack spacing={0.75} sx={{ position: 'relative' }}>
        <Typography variant="body2" color="text.secondary">
          {label}
        </Typography>
        <Typography variant="h4" sx={{ fontWeight: 650, lineHeight: 1.1 }}>
          {formatCompact(value)}
        </Typography>
        {caption && (
          <Typography variant="caption" color="text.secondary">
            {caption}
          </Typography>
        )}
      </Stack>
    </Paper>
  );
}
